import { render, staticRenderFns } from "./DatosBeneficiario.vue?vue&type=template&id=2bc0d9c8&scoped=true"
import script from "./DatosBeneficiario.vue?vue&type=script&lang=ts"
export * from "./DatosBeneficiario.vue?vue&type=script&lang=ts"
import style0 from "./DatosBeneficiario.vue?vue&type=style&index=0&id=2bc0d9c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc0d9c8",
  null
  
)

export default component.exports